document.addEventListener("DOMContentLoaded", function () {
  const initialButton = document.querySelector(".js-article__product--link");
  const productsToAdd = document.querySelectorAll(
    ".article-featured-products .card__info-container product-form.product--available"
  );
  let formData = { items: [] };

  productsToAdd.forEach((product) => {
    const id = product.querySelector("input[name='id']").value;
    const name = product.querySelector("input[name^='properties']").value;
    let properties = {};

    properties["article_" + name] = name;

    let obj = {
      id: id,
      quantity: 1,
      properties: properties,
    };

    formData.items.push(obj);
  });

  if (initialButton) {
    initialButton.addEventListener("click", updateCart);
  }

  /**
   * Updates cart js with new products
   */
  async function updateCart() {
    const fetchRequestOpts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };
  
    try {
      const response = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        fetchRequestOpts
      );
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
        }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      document.dispatchEvent(new CustomEvent('on:cart:add'));

  
    } catch (error) {
      console.error("Failed to update cart:", error);
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
        }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
    }
  }
});
